import { render } from "./LetterQuestions.vue?vue&type=template&id=40958f13"
import script from "./LetterQuestions.vue?vue&type=script&lang=js"
export * from "./LetterQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__